import React from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmCloseProductModal } from '../../ConfirmCloseProductModal';
import { formatProductNameList } from '../../utils/productNameUtils';

type Props = {
  productNames: string[];
  isPending: boolean;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
};

export const ClosureOnSaveConfirmation: React.FC<Props> = ({ productNames, isPending, onConfirm, onCancel }) => {
  const { t } = useTranslation();

  return (
    <ConfirmCloseProductModal
      title={t('pb.closeactiveebankingproductmodal.title', 'Remove product')}
      bodyText={t('pb.closeactiveebankingproductmodal.body', { productNames: formatProductNameList(productNames) })}
      confirmLabel={t('pb.closeactiveebankingproductmodal.submit', 'Close product')}
      cancelLabel={t('pb.closeactiveebankingproductmodal.cancel', 'Cancel')}
      isPending={isPending}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};
